import { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useClinicNotifications } from '../../hooks/useClinicNotifications';
import { useMarkNotificationRead } from '../../hooks/useMarkNotificationRead';

export function useNotificationsInbox({ autoSelectFirst }) {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [selected, setSelected] = useState(null);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const {
    notifications,
    isLoading,
    error: listError,
    refetch: getNotifications,
  } = useClinicNotifications();
  const { markAsRead: markNotificationRead, isLoading: isMarking } = useMarkNotificationRead();

  useEffect(() => {
    if (notifications.length === 0) return;

    const fromRoute = state?.selectedId
      ? notifications.find((notification) => String(notification.id) === String(state.selectedId))
      : null;

    setSelected((current) => {
      if (current) {
        return notifications.find((notification) => notification.id === current.id) ?? current;
      }
      return fromRoute ?? (autoSelectFirst ? notifications[0] : null);
    });
  }, [notifications, state, autoSelectFirst]);

  useEffect(() => {
    if (listError) {
      setShowErrorMessage(true);
      setErrorMessage('Não foi possível carregar as notificações.');
    }
  }, [listError]);

  const markAsRead = useCallback(
    (notificationId) => {
      markNotificationRead(notificationId)
        .then(() => {
          window.dispatchEvent(new Event('notification-read'));
          getNotifications();
        })
        .catch((returnFromApi) => {
          setShowErrorMessage(true);
          setErrorMessage('Não foi possível marcar como lida.');
          console.error('ops! ocorreu um erro' + returnFromApi);
          if (returnFromApi.response?.status === 401) {
            navigate('/expired-session');
          }
        });
    },
    [markNotificationRead, getNotifications, navigate],
  );

  return {
    notifications,
    isLoading,
    isMarking,
    selected,
    setSelected,
    markAsRead,
    showErrorMessage,
    setShowErrorMessage,
    errorMessage,
  };
}
